export enum TaskType {
  DOCUMENT_PERIOD_FILE_UPLOAD = 'document-period-file-upload',
  METRC_KEYS_SETUP = 'metrc-keys-setup',
  BIO_TRACK_KEY_SETUP = 'biotrack-keys-setup',
  SALES_DATA = 'client-sales-data-filling'
}
